export default __webpack_public_path__ + "static/media/flag.22b2a65e.svg";